import { useQuery } from '@tanstack/react-query'

import { useInterview } from '@/react-query/interview/interview'
import { getAudioChunks } from '@/views/screens/Interview/context/AudioRecorderContext/indexed-db'

const LOCAL_RECORDING_KEY = 'local-recording'

/**
 * Load any chunks already stored for this interview.
 * `enabled` prevents the query from running until we have an ID.
 * Chunks are immutable, so `staleTime: Infinity` is safe.
 */
export const useLocalRecording = () => {
  const { data: interview } = useInterview()

  return useQuery({
    queryKey: [LOCAL_RECORDING_KEY, interview?.id],
    queryFn: () => getAudioChunks(interview?.id || ''),
    enabled: Boolean(interview?.id),
  })
}
